import { cx } from "~/lib/legacy-utils"

const podiumColors = [
  "bg-linear-to-b from-amber-200 to-amber-400 text-amber-950 ring-amber-500/70",
  "bg-linear-to-b from-zinc-100 to-zinc-300 text-zinc-900 ring-zinc-400",
  "bg-linear-to-b from-orange-200 to-orange-400 text-orange-950 ring-orange-600/60",
]

export function AlternativeRank({
  position,
  variant = "tab",
  podium = true,
  className,
}: {
  position: number
  variant?: "tab" | "list"
  podium?: boolean
  className?: string
}) {
  return (
    <span
      data-alternative-rank={position}
      className={cx(
        "inline-flex shrink-0 items-center justify-center rounded-full font-semibold leading-none tabular-nums ring-1 ring-inset",
        variant === "tab"
          ? "h-6 min-w-9 px-2 text-xs shadow-xs"
          : "h-5 min-w-5 px-1 text-[0.6875rem]",
        (podium && podiumColors[position - 1]) ||
          "bg-background text-secondary-foreground ring-border",
        className,
      )}
    >
      <span className="sr-only">Position </span>
      {variant === "tab" && <span aria-hidden="true">#</span>}
      {position}
    </span>
  )
}
